// サンプルHtmlの追加
import commonClass from "./commonClass";

export default class insertHtmlClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._trg = '.js-ex_html-trg'; //サンプルボタン
    this._tgt = '.js-ex_html-tgt'; //サンプルが入力されるテキストエリア
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;
    var $trg = $(cls._trg);
    var $tmp = $(cls._tgt).children().eq(0).clone();

    $tmp.find('input[type="text"]').val('');
    $tmp.find('input[type="checkbox"]').prop('checked', false);
    $tmp.find('input[type="radio"]').prop('checked', false);
    $tmp.find('textarea').val('');
    $tmp.find('option').prop('selected', false);

    $trg.on('click', function() {
      $tmp.clone().appendTo(cls._tgt);
    });
  }
}